import { SxProps, Theme } from "@mui/material/styles";
import theme, {
  couleurPrimaire,
  erreur,
  gris2,
  yellow,
} from "../../../../theme";

const styles: SxProps<Theme> = [
  {
    "& .synthese": {
      "& p": {
        fontSize: 12,
        margin: 0,
        "&.parcours": {
          mb: "4px",
          "& > strong": {
            background: theme.palette.primary.main,
            p: "4px 16px",
            textTransform: "uppercase",
          },
        },
      },
      "& strong": {
        marginLeft: "4px",
      },
      "& h4": {
        position: "relative",
        fontWeight: "bold",
        textTransform: "uppercase",
        display: "flex",
        "& svg": {
          marginRight: 4,
        },
        "& img": {
          left: "-34px",
          position: "absolute",
          top: "-4px",
        },
      },
      "& h5": {
        fontSize: 12,
        textTransform: "uppercase",
        marginTop: 1,
        marginBottom: 0,
      },
    },
    "& .statut": {
      marginBottom: "0",
      "& p": {
        marginRight: "4px",
        fontSize: 13,
      },
      "& div": {
        fontSize: 13,
      },
    },
    "& .infoverifier-red": {
      color: erreur,
      fontWeight: "bold",
      fontSize: 12,
    },
    "& .messageStatut": {
      color: gris2,
      "& small": {
        marginLeft: "4px",
        fontStyle: "italic",
      },
    },
    "& .loyermaxConseille": {
      mt: 1,
      "& p": {
        marginRight: "4px",
        fontSize: 13,
      },
      "& div": {
        fontSize: 13,
      },
      "& a": {
        color: gris2,
        marginLeft: "4px",
      },
      "& label": {
        marginLeft: "4px",
        "& div": {
          border: "2px solid " + couleurPrimaire,
        },
      },
      "& button": {
        ml: 1,
      },
    },
    "& .textRight": {
      textAlign: "right",
      flex: 1,
      display: "flex",
      alignItems: "flex-end",
      flexDirection: "column",
      "& h4": {
        justifyContent: "flex-end",
      },
    },
    "& .candidats": {
      marginTop: 2,
      "& button": {
        marginLeft: 3,
      },
      "& .bouton-garant": {
        marginLeft: 0,
        marginTop: 3,
      },
    },
    "& .candidat": {
      background: "white",
      padding: 3,
      paddingLeft: "56px",
    },
    "& .blocCandidat": {
      marginTop: 3,
    },
    "& .noMargin": {
      "&$strong": {
        margin: 0,
      },
    },
    "& .modifyIcon": {
      marginLeft: "12px",
      position: "initial !important",
    },
    "& .contentChips": {
      flex: 1,
    },
    "& .contentBien": {
      paddingLeft: "36px",
      flex: 1,
    },
    "& .pieces": {
      display: "flex",
      alignItems: "center",
    },
    "& .icon": {
      fontSize: 14,
      marginRight: "4px",
    },
    "& .iconValid": {
      color: theme.palette.primary.main,
    },
    "& .iconFailed": {
      color: erreur,
    },
    "& .iconWait": {
      color: yellow,
    },
    "& .errorPiece": {
      margin: "8px 12px 12px 18px",
      width: "fit-content",
      maxWidth: "100%",
    },
    "& .statutNetheos": {
      display: "flex",
      fontSize: 12,
      marginBottom: "12px",
      "& > div": {
        marginLeft: 4,
      },
    },
    "& .downloadArchive": {
      paddingBottom: "12px",
      "& button": {
        marginLeft: "4px !important",
        color: gris2,
        fontSize: 12,
        marginRight: 8,
      },
    },
    "& .ajoutColoc": {
      marginBottom: "12px",
    },
    "& .containerStatut": {
      borderLeft: "5px solid " + theme.palette.secondary.main,
      paddingLeft: "12px",
      marginBottom: "24px",
    },
    "& .buttonPieces": {
      padding: 0,
      minWidth: 0,
      margin: 0,
      "&:hover, &:focus, &:active": {
        background: "transparent",
      },
    },
    "& .modifyStatut": {
      display: "flex",
      alignItems: "center",
      marginLeft: "24px",
      "& small": {
        paddingRight: 2,
      },
      "& > div": {
        flex: 1,
      },
      "& select": {
        width: 222,
        height: 30,
      },
      "& button": {
        marginLeft: 2,
      },
    },
    "& .autres-pieces": {
      mt: 4,
      "& h5": {
        mb: 1,
      },
      "& > div:first-of-type": {
        mb: 2,
      },
      "& .add-pieces": {
        maxWidth: 500,
      },
    },
  },
];

export default styles;
